var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 841.9",
    style: {
      enableBackground: "new 0 0 595.3 841.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FE4800;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.5,257L206.5,257c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C193,251,199,257,206.5,257z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.9,257L304.9,257c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C291.4,251,297.4,257,304.9,257z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.3,257L403.3,257c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C389.8,251,395.8,257,403.3,257z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.6,257L501.6,257c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C488.1,251,494.2,257,501.6,257z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.5,354.7L206.5,354.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C193,348.6,199,354.7,206.5,354.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.9,354.7L304.9,354.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C291.4,348.6,297.4,354.7,304.9,354.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.3,354.7L403.3,354.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C389.8,348.6,395.8,354.7,403.3,354.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.6,354.7L501.6,354.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C488.1,348.6,494.2,354.7,501.6,354.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.5,452.3L206.5,452.3c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C193,446.3,199,452.3,206.5,452.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.9,452.3L304.9,452.3c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C291.4,446.3,297.4,452.3,304.9,452.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.3,452.3L403.3,452.3c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C389.8,446.3,395.8,452.3,403.3,452.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.6,452.3L501.6,452.3c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C488.1,446.3,494.2,452.3,501.6,452.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.5,550L206.5,550c7.5,0,13.5-6,13.5-13.5l0,0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5l0,0 C193,543.9,199,550,206.5,550z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.9,550L304.9,550c7.5,0,13.5-6,13.5-13.5l0,0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5l0,0 C291.4,543.9,297.4,550,304.9,550z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.3,550L403.3,550c7.5,0,13.5-6,13.5-13.5l0,0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5l0,0 C389.8,543.9,395.8,550,403.3,550z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.6,550L501.6,550c7.5,0,13.5-6,13.5-13.5l0,0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5l0,0 C488.1,543.9,494.2,550,501.6,550z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.5,647.7L206.5,647.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C193,641.6,199,647.7,206.5,647.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.9,647.7L304.9,647.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C291.4,641.6,297.4,647.7,304.9,647.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M403.3,647.7L403.3,647.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C389.8,641.6,395.8,647.7,403.3,647.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.6,647.7L501.6,647.7c7.5,0,13.5-6,13.5-13.5v0c0-7.5-6-13.5-13.5-13.5h0c-7.5,0-13.5,6-13.5,13.5v0 C488.1,641.6,494.2,647.7,501.6,647.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.555d92610530cb7192dce9314553c37a.svg";
export { ForwardRef as ReactComponent };